export default class Modal {
    constructor(el) {
        this.el = el;
        this.isOpened = false;
        this.handleEscapeCloseBinded = this.handleEscapeClose.bind(this);
        this.externalEventListeners = {
            "open": [],
            "close": []
        }
    }

    getModal() {
        if (this.el.dataset && this.el.dataset.modalTarget) {
            return document.querySelector(this.el.dataset.modalTarget);
        }

        return this.el.querySelector(".modal");
    }

    getCloseElements() {
        return this.modal.querySelectorAll(".modal__close");
    }

    getOpenElements() {
        return this.el.querySelectorAll(".modal__open");
    }

    toggleModal(clickedElement = null, e) {
        e.preventDefault();

        this.isOpened = !this.isOpened;

        this.modal.classList.toggle("modal--active");
        document.body.classList.toggle("freeze");

        this.setEscapeEventListener();
        this.runExternalEventHandlers(this.isOpened ? "open" : "close", clickedElement) 
    }

    handleModalClick(e) {
        if (e.target !== e.currentTarget) return;

        this.toggleModal(null, e);
    }

    handleEscapeClose(e) {
        if (e.key === "Escape")
            this.toggleModal(null, e);
    }

    setEscapeEventListener() {
        this.isOpened ? document.addEventListener("keydown", this.handleEscapeCloseBinded, false) : document.removeEventListener("keydown", this.handleEscapeCloseBinded, false);
    }

    setEventListeners() {
        if (!this.openElements) return;

        this.openElements.forEach(element => element.addEventListener("click", this.toggleModal.bind(this, element)));
        this.modal.addEventListener("click", this.handleModalClick.bind(this));

        if (this.closeElements)
            this.closeElements.forEach(element => element.addEventListener("click", this.toggleModal.bind(this, element)));
    }

    runExternalEventHandlers(event, clickedElement) {
        if(this.externalEventListeners[event] && this.externalEventListeners[event].length !== 0)
            this.externalEventListeners[event].forEach(eventHandler => eventHandler.call(null, clickedElement, this.modal));
    }

    on(event, handler) {
        if (this.externalEventListeners[event] && typeof handler === "function") {
            this.externalEventListeners[event].push(handler);
        }
    }

    run() {
        this.modal = this.getModal();

        if(!this.modal) return;

        this.openElements = this.getOpenElements();
        this.closeElements = this.getCloseElements();
        this.setEventListeners();
    }
}